/* eslint-disable react/prop-types, no-shadow, react/jsx-no-bind */
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { googleOauthRedirect } from 'es6/core/paths';
import { openClient } from 'es6/redux/modules/auth/oauth';
import OauthButton from 'es6/components/registration/oauth/oauth-button';
import Providers from 'es6/core/oauth-providers';

// Window width and height for the popup.
const HEIGHT = 600;
const WIDTH = 500;

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ openClient }, dispatch);
}

function GoogleOauthButton({ children, openClient }) {
  return (
    <OauthButton provider={Providers.GOOGLE} onClick={openClient.bind(null, googleOauthRedirect(), WIDTH, HEIGHT)}>
      {children}
    </OauthButton>
  );
}

export default connect(null, mapDispatchToProps)(GoogleOauthButton);
